import timeZones from "timezones-list";

export const SENIORITY_OPTIONS = [
  "Junior (0-2 years)",
  "Mid-level (2-5 years)",
  "Senior (5+ years)",
  "Lead (8+ years)",
  "Principal (10+ years)",
];

export const SPECIALTY_OPTIONS = [
  "Frontend",
  "Backend",
  "Fullstack",
  "DevOps",
  "Mobile-iOS",
  "Mobile-Android",
  "Data science ML and AI",
  "Game Development",
  "BI and data analysis",
  "QA and testing",
  "Blockchain",
  "CMS (WordPress, Shopify, Joomla, etc.)",
  ".NET framework",
  "Security",
  "IT and support",
  "AI Prompt engineering"
];

export const TIME_OPTIONS = Array.from({ length: 24 }, (_, i) => {
  const hour = i % 12 || 12;
  const ampm = i < 12 ? 'AM' : 'PM';
  return `${hour}:00 ${ampm}`;
});

export const ALLOWED_TIMEZONES = [
  { value: "Etc/UTC", label: "UTC (Coordinated Universal Time)"},
  { value: "Pacific/Tahiti", label: "Tahiti (French Polynesia) (UTC-10:00)"},
  { value: "Pacific/Honolulu", label: "Hawaii (UTC-10:00)"},
  { value: "America/Anchorage", label: "Alaska (UTC-09:00)" },
  { value: "America/Los_Angeles", label: "Pacific Time (US & Canada) (UTC-08:00)" },
  { value: "America/Denver", label: "Mountain Time (US & Canada) (UTC-07:00)" },
  { value: "America/Phoenix", label: "Arizona (UTC-07:00)" },
  { value: "America/Chicago", label: "Central Time (US & Canada) (UTC-06:00)" },
  { value: "America/Mexico_City", label: "Mexico City (Mexico) (UTC-06:00)" },
  { value: "America/Bogota", label: "Bogota (Colombia) (UTC-05:00)" },
  { value: "America/New_York", label: "Eastern Time (US & Canada) (UTC-05:00)" },
  { value: "America/Toronto", label: "Toronto (Canada) (UTC-05:00)" },
  { value: "America/Panama", label: "Panama City (Panama) (UTC-05:00)" },
  { value: "America/Lima", label: "Lima (Peru) (UTC-05:00)" },
  { value: "America/Caracas", label: "Caracas (Venezuela) (UTC-04:00)" },
  { value: "America/Sao_Paulo", label: "Sao Paulo (Brazil) (UTC-03:00)" },
  { value: "America/Buenos_Aires", label: "Buenos Aires (Argentina) (UTC-03:00)" },
  { value: "Atlantic/Reykjavik", label: "Reykjavik (Iceland) (UTC+00:00)" },
  { value: "Europe/London", label: "London (UK) (UTC+00:00)" },
  { value: "Europe/Dublin", label: "Dublin (Ireland) (UTC+00:00)" },
  { value: "Europe/Lisbon", label: "Lisbon (Portugal) (UTC+00:00)" },
  { value: "Europe/Paris", label: "Paris (France) (UTC+01:00)" },
  { value: "Europe/Berlin", label: "Berlin (Germany) (UTC+01:00)" },
  { value: "Europe/Rome", label: "Rome (Italy) (UTC+01:00)" },
  { value: "Europe/Madrid", label: "Madrid (Spain) (UTC+01:00)" },
  { value: "Europe/Amsterdam", label: "Amsterdam (Netherlands) (UTC+01:00)" },
  { value: "Europe/Stockholm", label: "Stockholm (Sweden) (UTC+01:00)" },
  { value: "Europe/Zurich", label: "Zurich (Switzerland) (UTC+01:00)" },
  { value: "Europe/Athens", label: "Athens (Greece) (UTC+02:00)" },
  { value: "Africa/Cairo", label: "Cairo (Egypt) (UTC+02:00)" },
  { value: "Africa/Johannesburg", label: "Johannesburg (South Africa) (UTC+02:00)" },
  { value: "Europe/Istanbul", label: "Istanbul (Turkey) (UTC+03:00)" },
  { value: "Asia/Dubai", label: "Dubai (UAE) (UTC+04:00)" },
  { value: "Asia/Karachi", label: "Karachi (Pakistan) (UTC+05:00)" },
  { value: "Asia/Kolkata", label: "Mumbai (India) (UTC+05:30)" },
  { value: "Asia/Dhaka", label: "Dhaka (Bangladesh) (UTC+06:00)" },
  { value: "Asia/Bangkok", label: "Bangkok (Thailand) (UTC+07:00)" },
  { value: "Asia/Shanghai", label: "Beijing (China) (UTC+08:00)" },
  { value: "Asia/Singapore", label: "Singapore (UTC+08:00)" },
  { value: "Australia/Perth", label: "Perth (Australia) (UTC+08:00)" },
  { value: "Asia/Seoul", label: "Seoul (South Korea) (UTC+09:00)" },
  { value: "Asia/Tokyo", label: "Tokyo (Japan) (UTC+09:00)" },
  { value: "Australia/Adelaide", label: "Adelaide (Australia) (UTC+09:30)" },
  { value: "Australia/Sydney", label: "Sydney (Australia) (UTC+10:00)" },
  { value: "Pacific/Guam", label: "Guam (UTC+10:00)" },
  { value: "Pacific/Fiji", label: "Fiji (UTC+12:00)" },
  { value: "Pacific/Auckland", label: "Auckland (New Zealand) (UTC+13:00)" },
  { value: "Antarctica/McMurdo", label: "McMurdo Station (Antarctica) (UTC+13:00)" }
];

export const TIMEZONES = timeZones
  .filter(tz => ALLOWED_TIMEZONES.some(allowed => allowed.value === tz.tzCode))
  .map(tz => {
    const matchingAllowed = ALLOWED_TIMEZONES.find(allowed => allowed.value === tz.tzCode);
    return {
      value: tz.tzCode,
      label: matchingAllowed?.label || tz.name
    };
  });

  export const JOB_TYPES = [
    "Full-time",
    "Part-time",
    "Contract",
    "Freelance"
  ];